import { without } from 'lodash-es';

export const ADVANCED_METRICS = {
  mau_penetration: 'Monthly active user penetration',
  wau_penetration: 'Weekly active user penetration',
  sessions_penetration: 'Sessions penetration',
  time_spent_penetration: 'Time spent penetration',
  time_spent_segment_penetration: 'Time Spent Segment Penetration',
  average_sessions_per_dau: 'Average sessions per DAU',
  average_time_spent_per_dau: 'Average time spent per DAU',
  churn: 'User churn',
  ending_mau_app_segment_penetration: 'Cross-app overlap',
  devices_app_penetration: 'Cross-app DAU penetration',
  ending_mau_app_penetration: 'Cross-app MAU penetration',
  sessions_app_penetration: 'Cross-app Sessions penetration',
  tts_app_penetration: 'Cross-app Time Spent penetration',
  cross_app_time_spent_per_dau: 'Cross-app average time spent per DAU',
  cross_app_sessions_per_dau: 'Cross-app average sessions per DAU',
  // HELIOS METRICS
  avg_sessions_per_device: 'Average sessions per DAU',
  avg_tts_minutes_per_device: 'Avg Time Spent per DAU',
  devices_penetration: 'DAU Penetration',
  tts_penetration: 'Time Spent Penetration',
};

export const PANEL_VERSIONS = {
  'United States': 'us-blended-v1-r0-0-public',
  'United States-private': 'us-blended-v1-r0-0',
  APAC: 'bobble-v2-r1-0-apac-public',
  'APAC-private': 'bobble-v2-r1-0-apac',
  Europe: 'ipsos-v1-r1-0-public',
  'Europe-private': 'ipsos-v1-r1-0',
};

export const PUBLIC_PANEL_VERSIONS = {
  US: 'us-blended-v1-r0-0-public',
  APAC: 'bobble-v2-r1-0-apac-public',
  Europe: 'ipsos-v1-r1-0-public',
};

export const PANEL_ALLOWED_COUNTRIES = {
  US: ['US'],
  APAC: ['APAC'],
  Europe: ['GB'],
  'us-blended-v1-r0-0-public': ['US'],
  'us-blended-v1-r0-0': ['US'],
  'bobble-v2-r1-0-apac-public': ['APAC'],
  'bobble-v2-r1-0-apac': ['APAC'],
  'ipsos-v1-r1-0-public': ['GB'],
  'ipsos-v1-r1-0': ['GB'],
};

export const ADVANCED_METRICS_V2 = {
  dau_penetration: 'Daily active user penetration',
  wau_penetration: 'Weekly active user penetration',
  mau_penetration: 'Monthly active user penetration',
  sessions_penetration: 'Sessions penetration',
  time_spent_penetration: 'Time spent penetration',
  time_spent_segment_penetration: 'Time Spent Segment Penetration',
  average_sessions_per_dau: 'Average sessions per DAU',
  average_time_spent_per_dau: 'Average time spent per DAU',
  churn: 'User churn',

  cross_app_overlap: 'Cross-app overlap',
  cross_app_dau_penetration: 'Cross-app DAU penetration',
  cross_app_wau_penetration: 'Cross-app WAU penetration',
  cross_app_sessions_penetration: 'Cross-app Sessions penetration',
  cross_app_time_spent_penetration: 'Cross-app Time Spent penetration',
  cross_app_time_spent_per_dau: 'Cross-app average time spent per DAU',
  cross_app_sessions_per_dau: 'Cross-app average sessions per DAU',
};

export const EXISTING_CROSS_APP_METRICS_PANELS = ['us-blended-v1-r0-0-public', 'us-blended-v1-r0-0'];
export const CROSS_APP_PANEL_VERSION_MAPPING = { 'us-blended-v1-r0-0-public': 'mfour-v2-r3-0-public', 'us-blended-v1-r0-0': 'mfour-v2-r3-0' };

const metricsV2Public = without(Object.keys(ADVANCED_METRICS_V2), 'dau_penetration', 'cross_app_wau_penetration');
const metricsV2Private = without(Object.keys(ADVANCED_METRICS_V2), 'dau_penetration');

export const ADVANCED_METRICS_V2_MAP = {
  [PANEL_VERSIONS['United States']]: metricsV2Public,
  [PANEL_VERSIONS['United States-private']]: metricsV2Private,
  [PANEL_VERSIONS.APAC]: metricsV2Public,
  [PANEL_VERSIONS['APAC-private']]: metricsV2Private,
  [PANEL_VERSIONS.Europe]: metricsV2Public,
  [PANEL_VERSIONS['Europe-private']]: metricsV2Private,
};

export const ADVANCED_METRICS_APP = {
  mau_penetration: 'MAU Penetration',
  wau_penetration: 'WAU Penetration',
  sessions_penetration: 'Sessions Penetration',
  time_spent_penetration: 'Time Spent Penetration',
  time_spent_segment_penetration: 'Time Spent Segment Penetration',
  average_time_spent_per_dau: 'Avg Time Spent per DAU',
  average_sessions_per_dau: 'Avg Sessions per DAU',
  churn: 'Churn',
};

export const ADVANCED_METRICS_APP_DESCRIPTION = {
  mau_penetration: ' For each date, the number of devices that opened the app at least once over the last 30 days (rolling) divided by the total number of devices that had at least one app session (on any app) over the last 30 days (rolling)',
  wau_penetration: 'For each date, the number of devices that opened the app at least once in the most recent 7 days divided by the total number of devices that had at least one app session (on any app) during those days',
  sessions_penetration: 'For each date, the total number of sessions which occurred for that app on the most recent 7 days divided by the total number of sessions for all apps over the most recent 7 days across the panel or data set',
  time_spent_penetration: 'For each date, the total number of seconds spent inside that app on the most recent 7 days divided by the total number of seconds spent inside all apps on the most recent 7 days across the panel or data set',
  time_spent_segment_penetration: 'The total time spent which occurred for the app by [Segment] users that day divided by the total total time spent by [Segment] users for all apps that day across the panel or data set.',
  average_time_spent_per_dau: 'This is an average time spent per day, per app, per device.  This ignores sessions and measures the cumulative time spent across a 24 hour period per unique device.  Unlike other metrics this is the actual time spent in minutes and seconds and not a %. It is an average over the most recent 7 days',
  average_sessions_per_dau: 'This is an average sessions per day, per app, per device.  This measures the cumulative number of sessions spent across a 24 hour period per unique device.  Unlike other metrics this is the actual number of sessions and not a %. It is an average over the most recent 7 days',
  churn: 'The % of MAUs who were active between 30 and 60 days ago on an app but were not active on the app in the most recent 30 days.',
};

export const ADVANCED_METRICS_PERCENTAGE = [
  'mau_penetration',
  'wau_penetration',
  'churn',
  'sessions_penetration',
  'time_spent_penetration',
  'time_spent_segment_penetration',
];

export const COHORTS = {
  all: 'All Users',
  all_users: 'All Users',
  male_users: 'Male Users',
  female_users: 'Female Users',
  power_users: 'Power Users',
  casual_users: 'Casual Users',
  older_users: 'Older Users',
  younger_users: 'Younger Users',
  'age_17-25': 'Age 17-25',
  'age_26-35': 'Age 26-35',
  'age_36-45': 'Age 36-45',
  'age_46+': 'Age 46+',
};

export const V2_COHORTS = {
  all_users: 'All Users',
  male_users: 'Male Users',
  female_users: 'Female Users',
  power_users: 'Power Users',
  older_users: 'Older Users',
  younger_users: 'Younger Users',
  'age_17-25': 'Age 17-25',
  'age_26-35': 'Age 26-35',
  'age_36-45': 'Age 36-45',
  'age_46+': 'Age 46+',
};

const cohortsV2 = without(Object.keys(V2_COHORTS), 'younger_users');

export const V2_COHORTS_MAP = {
  [PANEL_VERSIONS['United States']]: cohortsV2,
  [PANEL_VERSIONS['United States-private']]: cohortsV2,
  [PANEL_VERSIONS.APAC]: cohortsV2,
  [PANEL_VERSIONS['APAC-private']]: cohortsV2,
  [PANEL_VERSIONS.Europe]: cohortsV2,
  [PANEL_VERSIONS['Europe-private']]: cohortsV2,
};

export const PANELS_REGIONS = [{
  label: 'North America',
  value: 'NORTHAM',
  list: ['US', 'CA'],
  panel_iso: 'US',
  panel_label: 'United States',
  panel_version: 'us-blended-v1-r0-0-public',
}, {
  label: 'APAC',
  value: 'APAC',
  list: [
    'AU', 'BD', 'BN', 'BT', 'CN', 'FJ', 'FM', 'HK', 'ID', 'IN', 'JP', 'KH', 'KR', 'LA',
    'LK', 'MN', 'MO', 'MY', 'NP', 'NZ', 'PG', 'PH', 'PK', 'PW', 'SB', 'SG', 'TH', 'TW',
    'VN',
  ],
  panel_iso: 'APAC',
  panel_label: 'APAC',
  panel_version: 'bobble-v2-r1-0-apac-public',
}, {
  label: 'Europe',
  value: 'europe',
  list: [
    'AD', 'AL', 'AT', 'BA', 'BE', 'BG', 'BY', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT',
    'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SK', 'UA',
  ],
  panel_iso: 'GB',
  panel_label: 'Europe',
  panel_version: 'ipsos-v1-r1-0-public',
}];

export const getPanelRegion = (countriesIso, availableDatasets) => {
  const panelIsoToDataset = {
    US: 'US',
    APAC: 'APAC',
    GB: 'Europe',
  };

  const panelRegionsToRegions = {
    NORTHAM: 'NORTHAM',
    APAC: 'APAC',
    europe: 'EMEA',
  };

  const panelRegions = availableDatasets
    ? PANELS_REGIONS.filter(({ panel_iso }) => (
      availableDatasets.includes(panelIsoToDataset[panel_iso] || panel_iso)))
    : PANELS_REGIONS;

  const panelRegion = panelRegions.find(({ value, list }) => {
    if (countriesIso.includes(panelRegionsToRegions[value] || value)) return true;

    const unionSize = new Set([...countriesIso, ...list]).size;

    return unionSize < (countriesIso.length + list.length);
  });

  return panelRegion || null;
};
